import {
  createColumnVisibilityStore,
  type ColumnDefinition,
} from "./createColumnVisibilityStore";

export const PAYMENT_GATEWAY_EVENT_COLUMNS = [
  { id: "occurredAt", label: "Time", locked: true },
  { id: "eventType", label: "Event", locked: true },
  { id: "outcome", label: "Outcome", locked: true },
  { id: "paymentCode", label: "Payment code" },
  { id: "user", label: "User" },
  { id: "gatewayCode", label: "Gateway code" },
  { id: "amount", label: "Amount" },
  { id: "detail", label: "Detail" },
  { id: "payload", label: "Actions", locked: true },
] as const satisfies readonly ColumnDefinition[];

export type PaymentGatewayEventColumnId =
  (typeof PAYMENT_GATEWAY_EVENT_COLUMNS)[number]["id"];

export const usePaymentGatewayEventColumnsStore =
  createColumnVisibilityStore<PaymentGatewayEventColumnId>({
    name: "admin.paymentGatewayEvents.columns",
    version: 1,
    columns: PAYMENT_GATEWAY_EVENT_COLUMNS,
  });
